import { render, staticRenderFns } from "./PublicGoals.vue?vue&type=template&id=b800a1e6"
import script from "./PublicGoals.vue?vue&type=script&lang=js"
export * from "./PublicGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b800a1e6')) {
      api.createRecord('b800a1e6', component.options)
    } else {
      api.reload('b800a1e6', component.options)
    }
    module.hot.accept("./PublicGoals.vue?vue&type=template&id=b800a1e6", function () {
      api.rerender('b800a1e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PublicGoals.vue"
export default component.exports